@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.compactContainer {
    align-items: center;
    background: var(--white);
    border: 1px solid var(--gray-07);
    border-radius: 8px;
    box-shadow: 0 2px 6px var(--gray-03);
    display: flex;
    justify-content: space-between;
    min-height: 38px;
    padding: 6px 10px;
}

.compactOfficeName {
    color: var(--brand-indigo);
    font-family: typography.$font-mont;
    font-size: 12px;
    font-weight: 600;
    line-height: 140%;
    min-width: 0;
    overflow-wrap: anywhere;
}

.compactAction {
    align-items: center;
    color: var(--brand-indigo);
    display: inline-flex;
    flex: 0 0 auto;
    font-family: typography.$font-mont;
    font-size: 11px;
    font-weight: 500;
    margin-left: 8px;
    gap: 4px;
    text-decoration: underline;
    text-transform: none;
    white-space: nowrap;
}

.compactActionIcon {
    height: 12px;
    width: 12px;
}

.container {
    max-width: 100%;
    width: 100%;
    background: var(--white);
    border: 1px solid var(--gray-07);
    box-shadow: 0px 2px 6px var(--gray-03);
    border-radius: 20px 20px 0px 0px;
    overflow:auto;
    margin-top: 10px;
    @include breakpoints.desktop {
        border-bottom: none;
    }
}

.footerPhoneLink {
    white-space: nowrap;
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.32px;
    text-align: right;
    vertical-align: middle;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 1px;
}

.phoneNumberText {
    display: inline-block;
    border-bottom: 1px solid currentColor;
    padding-bottom: 2px;
    line-height: 1;
}
.moveTop {
    top: 5%;
}

.headerSection {
    border-bottom: 0.5px solid var(--gray-07);
    height:35px;
    text-transform: uppercase;
    padding-top: 5px;
}

.heading {
    color: var(--blue-01);
    float: left;
    width:80%;
    padding: 1px 0px 0px 10px;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.12em;
    text-transform: none;
    color: var(--blue-01);
    @include breakpoints.desktop {
        font-size: 12px; 
        width:74%;
    }
    @include breakpoints.desktop-medium {
        font-size: 14px; 
        width:80%;
    }
    @include breakpoints.desktop-large {
        width:80%;
        font-family: typography.$font-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: 0px;
        vertical-align: middle;
    }
}

.action {
    font-family: typography.$font-mont;
    color: var(--blue-01);
    float:right;
    width:20%;
    padding: 1px 10px 0px 0px;
    text-align: right;
    text-decoration: underline;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    vertical-align: middle;
    text-transform: uppercase;

    @include breakpoints.desktop {
        font-weight: 400;
        font-style: normal;
        line-height: 100%;
        letter-spacing: 0px;
        text-align: right;
        text-decoration: underline;
        text-decoration-style: solid;
        text-decoration-thickness: 0%;

    }
    @include breakpoints.desktop-medium {
        font-size: 14px; 
        width:20%;
    }
    @include breakpoints.desktop-large {
        font-size: 16px; 
        width:20%;
    }
}

.contentSection {
    padding: 10px 10px 10px;
    height: auto;
    display: block;
    overflow: auto;
}

.contentLeft {
    float:left;
    width: 60%;
}

.contentRight {
    float:right;
    width:40%;
    text-align: right;
}

.officeName {
    font-size: 16px;
    color: black;
    font-weight: 600;
    @include breakpoints.desktop {
        font-size: 14px;
    }
    @include breakpoints.desktop-medium {
        font-size: 15px;
    }
    @include breakpoints.desktop-large {
        color: var(--Brand-Indigo, var(--brand-indigo));
        font-family: typography.$font-mont;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: 0px;
        vertical-align: middle;
    }
}

.officeAddress {
    color: rgba(0, 0, 0, 0.7);
    font-size: 14px;
    font-weight: 400;
    line-height: 140%;
    @include breakpoints.desktop {
        font-size: 12px;
    }
    @include breakpoints.desktop-medium {
        font-size: 13px;
    }
    @include breakpoints.desktop-large {
        font-family: typography.$font-mont;
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0px;
        vertical-align: middle;
        color: var(--Brand-Indigo, var(--brand-indigo));

    }
}

.officePhone {
    color: var(--blue-01);
    font-size: 12px;
    font-weight: 400;
}

.icon {
    margin-right: 5px;
}

.medicaid {
    color: var(--blue-01);
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: normal;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: right;
    vertical-align: middle;
}

.boldUnderline {
    font-family: typography.$font-mont;
    font-weight: 700;
    font-style: normal;
    font-size: 10px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: right;
    vertical-align: middle;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-thickness: 0%;
    text-decoration-line: underline;
}

.timings {
    color: var(--blue-01);
    font-size: 12px;
    font-weight: 400;
}
